import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "./AboutUs.css";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";

class AboutUs extends Component {
  render() {
    return (
      <div>
        <Header />
        <div style={{ marginTop: 30 }}>About US</div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(useStyles)(AboutUs);
